import {AnyAction} from 'redux';
import Types from '../../../actions/Types';

import Manual from '../../../../domain/entities/writer/Manual';

export default function reducer(
  state: {[key: number]: Manual} = {},
  action: AnyAction,
): {[key: number]: Manual} {
  switch (action.type) {
    case Types.IndexWriterManualsSuccess:
      return {
        ...state,
        ...action.payload.records.reduceRight(
          (obj: {[key: number]: Manual}, record: Manual) => {
            obj[record.id] = record;
            return obj;
          },
          {},
        ),
      };
    case Types.ShowWriterManualSuccess:
      return {
        ...state,
        [action.payload.id]: action.payload,
      };
    default:
      return state;
  }
}
